import React from 'react';
import styles from '../PrivacyPolicy.module.css';
import { Container } from 'reactstrap';
import PrivacyPolicyContentsOld from '@src/components/PrivacyPolicy/20200807/PrivacyPolicyContentsOld';
import Header from '@src/components/Base/Header/StandardHeader';
import DefaultHead from '@src/components/Base/Head/DefaultHead';
import MobileSearchbar from '@src/components/Base/Header/MobileSearchbar';
import WindowDimension from '@src/components/Base/WindowDimension';
import Footer from '@src/components/Base/Footer/Footer';
import Meta from '@src/components/Base/Head/Meta';

const PrivacyPolicyOld = () => {
  return (
    <div>
      <DefaultHead />
      <Meta title={'리걸엔진 | 개인정보 처리방침'} description={'개인정보 처리방침'} url={'privacypolicy/20200807'} />
      <Header imgSrc='../logo.svg' />
      {/* MobileSearchbar 추가됨  */}
      <MobileSearchbar />
      <Container className={styles.privacyPolicyContentBody}>
        <PrivacyPolicyContentsOld />
      </Container>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyOld;
